<template>
  <div class="auto-auth"></div>
</template>

<script>
import api from '../../utils/api'
import { mapMutations, mapActions } from 'vuex'
export default {
  name: 'auto-auth',
  data () {
    return {

    }
  },
  computed: {
    routeQuery () {
      return this.$route.query
    }
  },
  created () {
    this.$toast.loading('正在登录...')
    this.zhuoAutoLogin()
  },
  methods: {
    ...mapActions('store', [
      'setAuthorizationHandler'
    ]),
    ...mapMutations('autoLogin', [
      'updateHomeModelStatus'
    ]),

    // 卓望自动授权
    async zhuoAutoLogin () {
      if (!this.routeQuery.ztk) {
        this.$toast('授权失败')
        this.jumpRouter()
        return false
      }
      const data = await api.autoAuthForZhuo(this.routeQuery)
      this.$toast.clear()
      if (data) {
        this.setAuthorizationHandler(data.token).then(() => {
          this.updateHomeModelStatus(data.is_show)
          this.jumpRouter(this.routeQuery.name)
        })
      }
    },

    // 路由跳转
    jumpRouter (name) {
      if (name) {
        this.$router.replace({ name })
      } else {
        this.$router.replace({ name: 'home' })
      }
    }

  }
}
</script>

<style lang="less" scoped>
</style>
